import axios from 'axios';
import { customAxios } from '../../axios/CustomAxios';
import {myIpAddress} from "../../config";

// 전체 자산 리스트
const getAssetList =()=>{
    return customAxios.get(myIpAddress+'/asset');
}

export default getAssetList;